import router from '@/router';
import authService from "@/services/authService";
import toastService from '@/services/toastService';

export default {
  state:{
    token:localStorage.token,
  },
  getters:{
    token: state => state.token,
    refreshToken: state => state.refreshToken,
    loggedIn: state => !(state.token == null || state.token == '')
  },
  mutations:{
    setTokenAndRefreshToken: (state,token) => {
      localStorage.token = token;
      state.token = token;
    },
    logOut:state => {
      state.token = "";
      state.refreshToken = "";
      localStorage.token = "";
    }
  },
  actions:{
    login:({commit},payload) =>{
      authService.login(payload, (token) => {
        commit('setTokenAndRefreshToken', token);
        toastService.showSuccessToast("Login successful");
        router.push('/dashboard')
      }, error => {
      	toastService.showErrorToast("Cant login")
        console.log(error.response.data.message);
      });
    },
    logOut:({commit})=>{
    	console.log("Logging out");
      commit('logOut');
      router.push('/login')
    }
  }
};
